<p-confirm-dialog [draggable]="false" />

@let module = scanExclusionFormObj.module;
@if (loadingForm) {
	<div class="tw-flex tw-justify-center tw-py-6">
		<p-progress-spinner styleClass="p-progress-spinner-lg" strokeWidth="4"  />
	</div>
} @else {
	<mon-page-layout
		[header]="(isEditMode ? 'adminScanExclusions.form.header.edit' : 'adminScanExclusions.form.header.create') | transloco"
        [formLayout]="'single-column'"
    >
		<form #form="ngForm" (ngSubmit)="onSubmit(form)" class="admin-scan-exclusion-form" data-test="admin-scan-exclusion-form">
			<div class="tw-mb-6">
				<p-card>
					<h2 class="form-header tw-mt-0 tw-mb-2">{{'adminScanExclusions.form.detailsCard.header' | transloco }}</h2>
					@if (!isEditMode) {
						<div class="tw-flex tw-flex-col tw-gap-2 tw-mt-6">
							<p class="tw-m-0">
								{{ 'adminScanExclusions.form.detailsCard.subHeader' | transloco }}
							</p>
							<div class="tw-flex tw-flex-col tw-gap-4">
								@for (module of modules; track module.value) {
									<div class="field-checkbox">
										<p-radiobutton
											[inputId]="module.value"
											name="module"
											[value]="module.value"
											[(ngModel)]="scanExclusionFormObj.module"
											(ngModelChange)="onModuleChange()"
											[attr.data-test]="'admin-scan-exclusion-form-radio-' + module.value"
										/>
										<label [for]="module.value" class="tw-ml-2 tw-mb-0">{{ module.name | transloco }}</label>
									</div>
								}
							</div>
						</div>
					}
					<div class="tw-flex tw-flex-col tw-gap-2 tw-mt-4">
						<label class="tw-mb-0" for="title">
							{{ 'adminScanExclusions.form.detailsCard.titleLabel' | transloco }}
							<span class="tw-text-red-500">*</span></label>
						<input pInputText
							data-test="admin-scan-exclusion-form-input-title"
							id="title"
							name="title"
							[(ngModel)]="scanExclusionFormObj.title"
							required
							[placeholder]="'adminScanExclusions.form.detailsCard.titlePlaceholder' | transloco"
							#title="ngModel"
						/>
						@if (title.errors?.required && (title.dirty || title.touched)) {
							<small class="tw-text-red-500">
								{{ 'adminScanExclusions.form.detailsCard.titleRequired' | transloco }}
							</small>
						}
					</div>
					<div class="tw-flex tw-flex-col tw-gap-2 tw-mt-4">
						<label class="tw-mb-0" for="cms">
							{{ 'adminScanExclusions.form.detailsCard.cmsLabel' | transloco }}
						</label>
						<p-select
							data-test="admin-scan-exclusion-form-input-cms"
							inputId="cms"
							name="cms"
							[options]="cmsOptions"
							[(ngModel)]="scanExclusionFormObj.defaultForCms"
							optionLabel="name"
							optionValue="id"
							[filter]="true"
							filterBy="name"
							appendTo="body"
						/>
					</div>
					<div class="tw-flex tw-flex-col tw-gap-2 tw-mt-4">
						<label class="tw-mb-0" for="domains">
							{{ 'adminScanExclusions.form.detailsCard.domainsLabel' | transloco }}
						</label>
						<p-multiselect
							data-test="admin-scan-exclusion-form-input-domains"
							inputId="domains"
							name="domains"
							[options]="domainOptions"
							[(ngModel)]="scanExclusionFormObj.domains"
							optionLabel="title"
							[placeholder]="'adminScanExclusions.form.detailsCard.domainsPlaceholder' | transloco"
							[maxSelectedLabels]="5"
							selectedItemsLabel="{0} items selected"
							filterBy="title,url"
							(onFilter)="searchDomains($event)"
							(onFocus)="updateFilteredDomains()"
							(ngModelChange)="updateFilteredDomains()"
							(onClear)="scanExclusionFormObj.domains = []; updateFilteredDomains()"
							showToggleAll="false"
							[filterPlaceHolder]="'adminScanExclusions.form.detailsCard.domainsFilterPlaceholder' | transloco"
							[emptyMessage]="'adminScanExclusions.form.detailsCard.domainsEmptyMessage' | transloco"
							[emptyFilterMessage]="'adminScanExclusions.form.detailsCard.domainsFilterEmptyMessage' | transloco"
							appendTo="body"
							[loading]="loadingDomains"
							[showClear]="true"
							display="chip"
							[autofocusFilter]="true"
						/>
					</div>
				</p-card>
			</div>
			@if (module === 'accessibility') {
				@for (rule of accessibilityScanRules; track $index) {
					<div class="tw-mb-6" data-test="admin-scan-exclusion-form-accessibility-scan-section">
						<p-card>
							<div class="tw-flex tw-align-center tw-justify-between">
								<div>
									<h2 class="tw-mt-0 tw-mb-2 form-header">
										{{ 'adminScanExclusions.form.accessibilityCard.header' | transloco }}
									</h2>
									<p class="tw-my-0 form-subheader">
										{{ 'adminScanExclusions.form.accessibilityCard.subHeader' | transloco }}
									</p>
								</div>
								@if (rulesArray.length > 1) {
									<p-button
										icon="pi pi-trash"
										[ariaLabel]="'adminScanExclusions.form.removeExclusionAriaLabel' | transloco"
										variant="outlined"
										data-test="admin-scan-exclusion-form-remove-accessibility-rule-button"
										(onClick)="removeExclusion($index)"
									/>
								}
							</div>
							<div class="tw-flex tw-flex-col tw-gap-2 tw-mt-6">
								<label class="tw-block" [for]="'exclusionType-'+$index">
									{{ 'adminScanExclusions.form.accessibilityCard.typeLabel' | transloco }}
									<span class="tw-text-red-500">*</span>
									<span class="pi pi-info-circle cursor-pointer pl-1"
										[pTooltip]="'adminScanExclusions.form.accessibilityCard.typeTooltip' | transloco"
										[tooltipOptions]="tooltipOptions"
										aria-hidden="true">
									</span>
								</label>
								<p-select
									data-test="admin-scan-exclusion-form-input-accessibility-type"
									[inputId]="'exclusionType-'+$index"
									[name]="'exclusionType-'+$index"
									[placeholder]="'adminScanExclusions.form.accessibilityCard.typePlaceholder' | transloco"
									[(ngModel)]="rule.type"
									[options]="exclusionTypeOptions"
									[optionLabel]="'name'"
									[optionValue]="'value'"
									required
									#exclusionType="ngModel"
									appendTo="body"
								/>
								@if (exclusionType.errors?.required && (exclusionType.dirty || exclusionType.touched)) {
									<small class="tw-text-red-500">
										{{ 'adminScanExclusions.form.accessibilityCard.typeRequired' | transloco }}
									</small>
								}
							</div>

							<div class="tw-flex tw-flex-col tw-gap-2 tw-mt-4">
								<label class="tw-block" [for]="'exclusionValue-'+$index">
									{{ 'adminScanExclusions.form.accessibilityCard.valueLabel' | transloco }}
									<span class="tw-text-red-500">*</span>
									<span class="pi pi-info-circle cursor-pointer pl-1"
										[pTooltip]="'adminScanExclusions.form.accessibilityCard.valueTooltip' | transloco"
										[tooltipOptions]="tooltipOptions"
										aria-hidden="true">
									</span>
								</label>
								<input
									data-test="admin-scan-exclusion-form-input-accessibility-value"
									pInputText
									type="text"
									[id]="'exclusionValue-'+$index"
									[name]="'exclusionValue-'+$index"
									[(ngModel)]="rule.value"
									required
									#exclusionValue="ngModel"
									[placeholder]="'adminScanExclusions.form.accessibilityCard.valuePlaceholder' | transloco"
								/>
								@if (exclusionValue.errors?.required && (exclusionValue.dirty || exclusionValue.touched)) {
									<small class="tw-text-red-500">
										{{ 'adminScanExclusions.form.accessibilityCard.valueRequired' | transloco }}
									</small>
								}
							</div>

							<div class="tw-flex tw-flex-col tw-gap-2 tw-mt-4">
								<label class="tw-block" [for]="'check-'+$index">
									{{ 'adminScanExclusions.form.accessibilityCard.checksLabel' | transloco }}
								</label>
								<p-multiSelect
									data-test="admin-scan-exclusion-form-input-accessibility-checks"
									[inputId]="'check-'+$index"
									[name]="'check-'+$index"
									[(ngModel)]="rule.checks"
									[placeholder]="'adminScanExclusions.form.accessibilityCard.checksPlaceholder' | transloco"
									[fluid]="true"
									optionLabel="name"
									[options]="filteredChecks"
									(onFilter)="searchChecks($event, $index)"
									(onFocus)="updateFilteredChecks($index)"
									(ngModelChange)="updateFilteredChecks($index)"
									filterBy="name"
									[autofocusFilter]="true"
									showToggleAll="false"
                                    [showClear]="true"
                                    (onClear)="rule.checks = []; updateFilteredChecks($index)"
									[maxSelectedLabels]="0"
									selectedItemsLabel="{0} items selected">
									<ng-template let-check pTemplate="item">
										<div class="tw-text-wrap tw-max-w-full" [innerHTML]="check.name"></div>
									</ng-template>
								</p-multiSelect>
							</div>
						</p-card>
					</div>
				}
			} @else {
				@for (rule of scanRules; track $index) {
					<div class="tw-mb-6" data-test="admin-scan-exclusion-form-other-scan-section">
						<p-card>
							<div class="tw-flex tw-align-center tw-justify-between">
								<div>
									<h2 class="tw-mt-0 tw-mb-2 form-header">
										{{ 'adminScanExclusions.form.scanCard.header' | transloco }}
									</h2>
									<p class="tw-my-0 form-subheader">
										{{ 'adminScanExclusions.form.scanCard.subHeader' | transloco }}
									</p>
								</div>
								@if (scanRules.length > 1) {
									<p-button
										icon="pi pi-trash"
										[ariaLabel]="'adminScanExclusions.form.removeExclusionAriaLabel' | transloco"
										variant="outlined"
										data-test="admin-scan-exclusion-form-remove-scan-rule-button"
										(onClick)="removeExclusion($index)"
									/>
								}
							</div>
							<div class="tw-flex tw-flex-col tw-gap-2 tw-mt-6">
								<label class="tw-block" [for]="'targetSelector-'+$index">
									{{ 'adminScanExclusions.form.scanCard.targetSelectorLabel' | transloco }}
									<span class="tw-text-red-500">*</span>
								</label>
								<input
									pInputText
									data-test="admin-scan-exclusion-form-input-target-selector"
									[id]="'targetSelector-'+$index"
									[name]="'targetSelector-'+$index"
									[(ngModel)]="rule.value"
									[placeholder]="'adminScanExclusions.form.scanCard.targetSelectorPlaceholder' | transloco"
									required
									targetSelectorValidator
									#targetSelector="ngModel"
								/>
								@if (targetSelector.errors?.required && (targetSelector.dirty || targetSelector.touched)) {
									<small class="tw-text-red-500">
										{{ 'adminScanExclusions.form.scanCard.targetSelectorRequired' | transloco }}
									</small>
								}
								@if (targetSelector.errors?.invalidTargetSelector && (targetSelector.dirty || targetSelector.touched)) {
									<small class="tw-text-red-500">
										{{ 'adminScanExclusions.form.scanCard.targetSelectorInvalid' | transloco }}
									</small>
								}
							</div>
						</p-card>
					</div>
				}
			}
			<p-button
				data-test="admin-scan-exclusion-form-add-new-button"
				icon="pi pi-plus"
				[label]="'adminScanExclusions.form.addButtonLabel' | transloco"
				variant="outlined"
				[disabled]="savingForm"
				(onClick)="addExclusion()"
			/>
			<div class="form-actions">
				<p-button
					data-test="admin-scan-exclusion-form-cancel-button"
					[label]="'adminScanExclusions.form.cancelButtonLabel' | transloco"
					variant="text"
					[disabled]="savingForm"
					(onClick)="onCancel()"
				/>
				<p-button
					data-test="admin-scan-exclusion-form-save-button"
					type="submit"
					[label]="'adminScanExclusions.form.saveButtonLabel' | transloco"
					[loading]="savingForm"
					styleClass="tw-ml-4"
					[disabled]="form.invalid"
				/>
			</div>
		</form>
	</mon-page-layout>
}
